import { useSubheader } from "../../../../_metronic/layout/index.js"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import React, { useCallback, useEffect, useState } from "react"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { CardBody } from "../../../../_metronic/_partials/controls/index.js"
import YearPicker from "../../../../component/molecule/YearPicker/index.jsx"
import { EmptyCard, TableSkeleton, TableView } from "../../../../component/index.jsx"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import {
  formatterRowComponent,
  initialFilterTable
} from "../../../../component/atoms/Tabel/index.jsx"
import { stringFormatting, toThousandConvert } from "../../../helpers/TextHelper.js"
import { Link, useHistory } from "react-router-dom"
import { useLocation } from "react-router"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import {
  clearDataFO,
  getListRegionalKpiGoalSetting
} from "../../../../redux/actions/FieldOfficerAction.jsx"
import { KPI_GOAL_SETTING_TAB, UNIT_STRING } from "../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { DetailSvgIcon } from "../../../../component/atoms/Icons/SVG/index.jsx"
import { loadUserLogin } from "../../../service/userManagementAction.js"

export function ListRegionalKPIGoalSetting() {
  const subheader = useSubheader()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { General, FieldOfficer } = useSelector((state) => state)
  const history = useHistory()
  const location = useLocation()
  const privileges = loadUserLogin().privilege
  const user = loadUserLogin()
  const getYearFromUrl = () => {
    const params = new URLSearchParams(location.search)
    const yearParam = params.get('year')
    if (yearParam && !isNaN(Number(yearParam))) {
      return new Date(Number(yearParam), 0)
    }
    return new Date()
  }
  const [selectedYear, setSelectedYear] = useState(getYearFromUrl())
  const [currentParam, setCurrentParam] = useState({
    ...initialFilterTable,
  })

  useEffect(() => {
    subheader.setTitle(t("sub_header_kpi_goal_setting"))
    subheader.setButton(null)
    return () => {
      dispatch(clearDataFO())
    }
  }, [])

  useEffect(() => {
    if (user?.regional_id) {
      history.push(RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(user?.regional_id, KPI_GOAL_SETTING_TAB.THIS_YEAR, new Date().getFullYear()))
    } else {
      fetchListRegional(location?.search)
    }
  }, [location?.search])

  useEffect(() => {
    changePage(currentParam)
  }, [selectedYear])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const yearParam = params.get('year')
    if (yearParam && !isNaN(Number(yearParam))) {
      const yearDate = new Date(Number(yearParam), 0)
      if (selectedYear.getFullYear() !== yearDate.getFullYear()) {
        setSelectedYear(yearDate)
      }
    }
  }, [location.search])

  const fetchListRegional = (param) => {
    dispatch(getListRegionalKpiGoalSetting(param))
  }

  const changePage = useCallback(
    (param) => {
      const baseParam = { ...currentParam, ...param, year: selectedYear.getFullYear() }
      if (param.sortField != null) {
        baseParam.sort = param?.sortField ? param.sortField + "," + param.sortOrder : ""
      }
      const urlParam = getUrlParsingPageFilter(baseParam)
      setCurrentParam(baseParam)
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, selectedYear, history]
  )

  const columnProperties = [
    {
      text: t("label_regional_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-bolder"}>{stringFormatting(e.regional_name)}</span>
            </div>
          </>
        )
      }
    },
    {
      text: t("table_header_regional_head_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-normal font-size-lg"}>{stringFormatting(e.regional_head_name)}</span>
            </div>
          </>
        )
      }
    },
    {
      text: t("label_paddy"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-normal font-size-lg"}>{stringFormatting(toThousandConvert(e.paddy), UNIT_STRING.HA)}</span>
            </div>
          </>
        )
      }
    },
    {
      text: t("label_corn"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-normal font-size-lg"}>{stringFormatting(toThousandConvert(e.corn), UNIT_STRING.HA)}</span>
            </div>
          </>
        )
      }
    },
    {
      text: t("label_corn_production"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg d-flex flex-column"}>
              <span className={"font-weight-normal font-size-lg"}>{stringFormatting(toThousandConvert(e.corn_production), UNIT_STRING.HA)}</span>
            </div>
          </>
        )
      }
    },
    {
      text: t("label_detail"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div>
            {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1 && (
              <Link
                data-test={"detail-forecast"}
                to={RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(
                  e.id,
                  KPI_GOAL_SETTING_TAB.THIS_YEAR,
                  selectedYear.getFullYear()
                )}>
                <OverlayTrigger
                  overlay={<Tooltip id="products-edit-tooltip">Detail {e.regional_name}</Tooltip>}>
                  <div className="btn btn-icon btn-detail btn-hover-secondary btn-md mx-3">
                    <DetailSvgIcon size="2x" />
                  </div>
                </OverlayTrigger>
              </Link>
            )}
          </div>
        )
      }
    },
  ]
  return (
    <Card>
      <CardBody>
        <div className={"d-flex justify-content-between align-items-center"}>
          <h2 className={"font-weight-bolder"}>
            {t("sub_header_kpi_regional_information")}
          </h2>
          <div>
            <YearPicker
              year={selectedYear}
              setYear={(date) => {
                setSelectedYear(date)
              }}
              filterDate={(date) => date.getFullYear() <= new Date().getFullYear() && date.getFullYear() >= 2025}
            />
          </div>
        </div>
        <Card className={"mt-8"}>
          <CardBody>
            {General?.loading ? (
              <TableSkeleton column={5} row={10} />
            ) : (FieldOfficer?.pageData ?? []).length === 0 ? (
              <EmptyCard
                image={
                  ILLUSTRATION_CONSTANTS.EMPTY_STATE
                }
                body={
                  t("messages_response_empty_state", { name: "Target Regional" })
                }
              />
            ) : (
              ""
            )}
            <TableView
              dataTable={FieldOfficer?.pageData ?? []}
              currentPage={FieldOfficer?.page?.currentPage ?? 1}
              currentElement={FieldOfficer?.page?.currentElement ?? 10}
              totalCount={FieldOfficer?.page?.totalCount ?? 0}
              columnProperties={columnProperties}
              callbackAfterPageChange={changePage}
              loadingGetData={General?.loading}
              initialFilterTable={currentParam}
              ignoreSinglePage
              rowClasses={() => {
                return "cursor-pointer"
              }}
            />
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  )
}

